import {
    StethoscopeIcon,
    TruckIcon,
    InfinityIcon,
    CheckCircleIcon,
    SubtitlesSlashIcon,
    FadersHorizontalIcon,
    HandCoinsIcon,
    SealPercentIcon,
} from "@phosphor-icons/react/ssr";

export const pricingItems = [
    {
        id: "prescription-treatment",
        icon: <StethoscopeIcon weight="light" size={44} />,
        title: "Prescription treatment",
    },
    {
        id: "shipping",
        icon: <TruckIcon weight="light" size={44} />,
        title: "Free & fast shipping",
    },
    {
        id: "clinical-follow-up",
        icon: <InfinityIcon weight="light" size={44} />,
        title: "Unlimited clinical follow-up",
    },
    {
        id: "hsa-fsa",
        icon: <CheckCircleIcon weight="light" size={44} />,
        title: "HSA/FSA Eligible",
    },
    {
        id: "cancel-anytime",
        icon: <SubtitlesSlashIcon weight="light" size={44} />,
        title: "No insurance needed",
    },
    {
        id: "dose-adjustments",
        icon: <FadersHorizontalIcon weight="light" size={44} />,
        title: "Dose adjustments if needed*",
    },
    {
        id: "money-back",
        icon: <HandCoinsIcon weight="light" size={44} />,
        title: <>Cancel <br className="md:hidden" /> anytime</>,
    },
    {
        id: "fullscript-discount",
        icon: <SealPercentIcon weight="light" size={44} />,
        title: "20% off any supplement in FullScript",
    },
];
